import { GetPostResponse, ListPostsResponse } from '@listening/api-contract';
import { ApiClient } from '@listening/api-contract/api-client-tag';
import { ssrApiQuery } from '@listening/frontend/query/api-runtime';
import { Duration, Effect } from 'effect';
import { Atom } from 'effect/reactivity';

const BLOG_PAGE_SIZE = 15;

// The CDN keeps a blog page for an hour, so the browser keeps what came with it
// as long.
const staleTime = Duration.hours(1);

export const blogPostsPageAtom = Atom.family((page: number) =>
  ssrApiQuery(
    Effect.flatMap(ApiClient, (api) =>
      api.Blog.ListPosts({ query: { page, size: BLOG_PAGE_SIZE } }),
    ),
    {
      key: `blog-posts:${page.toString()}`,
      success: ListPostsResponse,
      staleTime,
    },
  ),
);

export const blogPostAtom = Atom.family((slug: string) =>
  ssrApiQuery(
    Effect.flatMap(ApiClient, (api) => api.Blog.GetPost({ params: { slug } })),
    { key: `blog-post:${slug}`, success: GetPostResponse, staleTime },
  ),
);
